<script setup>
  import { defineProps, defineEmits } from 'vue';

  const props = defineProps({
    selectedLayout: {
      type: String,
      required: true,
      default: 'grid-6-columns'
    }
  });


  const emit = defineEmits(['update:layout']);
</script>

<template>
  <div class="layout-controls">
    <div
      class="grid-colours-1"
      :class="{ 'selected': props.selectedLayout === 'grid-6-columns' }"
      @click="emit('update:layout', 'grid-6-columns')">
      <svg width="16" height="16" viewBox="0 0 16 16"
           fill="none">
        <rect width="6" height="6" rx="2" fill="#999999" />
        <rect x="10" width="6" height="6" rx="2" fill="#999999" />
        <rect y="10" width="6" height="6" rx="2" fill="#999999" />
        <rect x="10" y="10" width="6" height="6" rx="2" fill="#999999" />
      </svg>
    </div>

    <div
      class="grid-colours-2"
      :class="{ 'selected': props.selectedLayout === 'grid-3-columns' }"
      @click="emit('update:layout', 'grid-3-columns')">
      <svg width="16" height="16" viewBox="0 0 16 16"
           fill="none">
        <rect width="16" height="1" fill="#999999" />
        <rect y="5" width="16" height="1" fill="#999999" />
        <rect y="10" width="16" height="1" fill="#999999" />
        <rect y="15" width="16" height="1" fill="#999999" />
      </svg>
    </div>
  </div>
</template>

<style scoped>
  .layout-controls {
    display: flex;
    gap: 8px; /* Espaçamento entre os botões */
    padding: 5px;
  }

  .layout-option {
    cursor: pointer;
    padding: 5px;
    border-radius: 4px;
    transition: background-color 0.2s;
    border: 1px solid transparent;

    &.selected {
      /* Estilo para o botão ativo */
      background-color: #333;
      border-color: #333;

      svg rect {
        fill: white; /* Cor do ícone em branco quando selecionado */
      }
    }

    &:hover:not(.selected) {
      background-color: #eee;
    }
  }

  /* Ajuste para garantir que a cor do ícone mude */
  .layout-option svg rect {
    transition: fill 0.2s;
  }
</style>
